import {css, Theme} from "@emotion/react";

import {mr, ph} from "@pg-design/helpers-css";
import {GalleryOutlineIcon, MapIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {ITabItem, Tabs} from "@pg-design/tabs";

import {gtmOfferGalleryEvents} from "../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {insertIf} from "../../utils/insert_if";
import {OfferModalActiveTab} from "../types/OfferModalActiveTab";

interface IProps {
    modalState: OfferModalActiveTab | undefined;
    handleGalleryModalChange: (tab: OfferModalActiveTab) => void;
    hasPlanImage: boolean;
}

export const GalleryModalTabs = (props: IProps) => {
    const tabs = getTabs(props.hasPlanImage);

    const handleTabChange = (tab: OfferModalActiveTab) => {
        gtmOfferGalleryEvents.onGalleryTabClick(tab);
        props.handleGalleryModalChange(tab);
    };

    return <Tabs value={props.modalState} css={wrapperStyle} tabs={tabs} onChange={handleTabChange} variant="line" activeColor="invert-dark" color="gray" />;
};

const getTabs: (hasPlanImage: boolean) => ITabItem<OfferModalActiveTab>[] = (hasPlanImage) => [
    {
        title: (
            <div css={[holderStyles]}>
                <GalleryOutlineIcon size="2" css={[showOnDesktop]} />
                Galeria
            </div>
        ),
        value: OfferModalActiveTab.GALLERY
    },
    {
        title: (
            <div css={[holderStyles]}>
                <GalleryOutlineIcon size="2" css={[showOnDesktop]} />
                Zdjęcia z budowy
            </div>
        ),
        value: OfferModalActiveTab.CONSTRUCTION_GALLERY
    },
    ...insertIf(hasPlanImage, {
        title: (
            <div css={[holderStyles]}>
                <PropertyPlanIcon size="2" css={[showOnDesktop]} />
                Rzut
            </div>
        ),
        value: OfferModalActiveTab.PLAN
    }),
    {
        title: (
            <div css={[holderStyles]}>
                <MapIcon size="2" css={[showOnDesktop]} />
                Mapa
            </div>
        ),
        value: OfferModalActiveTab.MAP
    }
];

const wrapperStyle = (theme: Theme) => css`
    overflow-x: hidden;
    width: 100%;
    div {
        display: flex;
        justify-content: center;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        div {
            justify-content: flex-start;
        }
    }
`;

const holderStyles = (theme: Theme) => css`
    display: flex;
    align-items: center;
    flex: 1 0 100%;
    @media (min-width: ${theme.breakpoints.md}) {
        ${ph(0)}
    }
`;

const showOnDesktop = (theme: Theme) => css`
    ${mr(2)}
    display: none;
    @media (min-width: ${theme.breakpoints.md}) {
        display: block;
    }
`;
import {css, Theme} from "@emotion/react";

import {mr, ph} from "@pg-design/helpers-css";
import {GalleryOutlineIcon, MapIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {ITabItem, Tabs} from "@pg-design/tabs";

import {gtmOfferGalleryEvents} from "../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {insertIf} from "../../utils/insert_if";
import {OfferModalActiveTab} from "../types/OfferModalActiveTab";

interface IProps {
    modalState: OfferModalActiveTab | undefined;
    handleGalleryModalChange: (tab: OfferModalActiveTab) => void;
    hasPlanImage: boolean;
}

export const GalleryModalTabs = (props: IProps) => {
    const tabs = getTabs(props.hasPlanImage);

    const handleTabChange = (tab: OfferModalActiveTab) => {
        gtmOfferGalleryEvents.onGalleryTabClick(tab);
        props.handleGalleryModalChange(tab);
    };

    return <Tabs value={props.modalState} css={wrapperStyle} tabs={tabs} onChange={handleTabChange} variant="line" activeColor="invert-dark" color="gray" />;
};

const getTabs: (hasPlanImage: boolean) => ITabItem<OfferModalActiveTab>[] = (hasPlanImage) => [
    {
        title: (
            <div css={[holderStyles]}>
                <GalleryOutlineIcon size="2" css={[showOnDesktop]} />
                Galeria
            </div>
        ),
        value: OfferModalActiveTab.GALLERY
    },
    {
        title: (
            <div css={[holderStyles]}>
                <GalleryOutlineIcon size="2" css={[showOnDesktop]} />
                Zdjęcia z budowy
            </div>
        ),
        value: OfferModalActiveTab.CONSTRUCTION_GALLERY
    },
    ...insertIf(hasPlanImage, {
        title: (
            <div css={[holderStyles]}>
                <PropertyPlanIcon size="2" css={[showOnDesktop]} />
                Rzut
            </div>
        ),
        value: OfferModalActiveTab.PLAN
    }),
    {
        title: (
            <div css={[holderStyles]}>
                <MapIcon size="2" css={[showOnDesktop]} />
                Mapa
            </div>
        ),
        value: OfferModalActiveTab.MAP
    }
];

const wrapperStyle = (theme: Theme) => css`
    overflow-x: hidden;
    width: 100%;
    div {
        display: flex;
        justify-content: center;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        div {
            justify-content: flex-start;
        }
    }
`;

const holderStyles = (theme: Theme) => css`
    display: flex;
    align-items: center;
    flex: 1 0 100%;
    @media (min-width: ${theme.breakpoints.md}) {
        ${ph(0)}
    }
`;

const showOnDesktop = (theme: Theme) => css`
    ${mr(2)}
    display: none;
    @media (min-width: ${theme.breakpoints.md}) {
        display: block;
    }
`;
